module.exports = __webpack_public_path__ + "img/skills-fireclaws-dru-3.61d837dd.png";